const SidebarStatus = {
  OPEN: 'open',
  CLOSE: 'close',
} as const;

export { SidebarStatus };
